import { useDispatch } from 'react-redux';
import type { AppDispatch } from '@/store';

// Custom hook that correctly handles dispatch with async thunk
export const useAppDispatch = () => useDispatch<AppDispatch>(); 